import { useEffect, useState } from "react";
import { useStore } from "../../../../store";
import {
  RoomReviewCard,
  RoomReviewCardMobile,
  RoomReviewSkeleton,
} from "./RoomReviewCard";

export default function MyRoomsReviews() {
  const { userStore } = useStore();

  const [isinstructorsReviewsLoading, setIsinstructorsReviewsLoading] =
    useState<boolean>(true);

  const [allReviews, setAllReviews] = useState<any[]>([]);
  const [instructorsReviews, setinstructorsReviews] = useState<any[]>([]);
  const [pagesNumber, setPagesNumber] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const reviewsPerPage = 5;

  useEffect(() => {
    userStore
      .getMyClassroomsFeedbacks()
      .then((feedbacks) => {
        if (feedbacks) {
          if (feedbacks.length > 0) {
            setPagesNumber(Math.ceil(feedbacks.length / 5));
            setAllReviews(feedbacks);
            setinstructorsReviews(feedbacks.slice(0, 5));
          } else {
            setAllReviews([]);
            setinstructorsReviews([]);
            setPagesNumber(1);
          }
          setIsinstructorsReviewsLoading(false);
        } else {
          setIsinstructorsReviewsLoading(false);
        }
      })
      .catch((error) => {
        console.log("errorrr", error);
        setIsinstructorsReviewsLoading(false);
      });
  }, []);

  useEffect(() => {
    const startIdx = (currentPage - 1) * 5;
    const endIdx = startIdx + 5;
    setinstructorsReviews(allReviews.slice(startIdx, endIdx));
  }, [currentPage, allReviews]);

  const goToNextPage = () => {
    if (currentPage < pagesNumber) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const goToPeviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const deleteReview = async (reviewId: string) => {    
    try {
      await userStore.deleteMyClassroomFeedback(reviewId);

      const updatedReviews = allReviews.filter((item) => item.id !== reviewId);
      setAllReviews(updatedReviews);

      const newPagesNumber = Math.max(
        Math.ceil(updatedReviews.length / reviewsPerPage),
        1
      );
      setPagesNumber(newPagesNumber);

      setCurrentPage((prev) => Math.min(prev, newPagesNumber));
    } catch (error) {
      console.error("error deleting instructor review", error);
    }
  };

  return (
    <>
      {isinstructorsReviewsLoading && (
        <div className="w-full border-[1px] border-[#DFDFDF] rounded-[20px] p-[8px]">
          <div className="w-full flex flex-col justify-start items-start spacey-y-[8px]">
            {Array(5)
              .fill(null)
              .map((_, index) => (
                <RoomReviewSkeleton key={index} />
              ))}
          </div>
        </div>
      )}
      {!isinstructorsReviewsLoading && instructorsReviews.length > 0 && (
        <div className="w-full flex flex-col justify-center items-center space-y-[30px] ">
          {/* instructor reviews list */}
          <div className="w-full border-[1px] border-[#DFDFDF] rounded-[20px] p-[8px]">
            <div className="w-full hidden md:flex flex-col justify-start items-start space-y-[8px]">
              {instructorsReviews.map((instructorReview: any) => (
                <RoomReviewCard
                  key={instructorReview.id}
                  roomReview={instructorReview}
                  deleteReview={deleteReview}
                ></RoomReviewCard>
              ))}
            </div>
            <div className="w-full flex md:hidden flex-col justify-start items-start space-y-[10px]">
              {instructorsReviews.map((instructorReview: any) => (
                <RoomReviewCardMobile
                  key={instructorReview.id}
                  roomReview={instructorReview}
                  deleteReview={deleteReview}
                ></RoomReviewCardMobile>
              ))}
            </div>
          </div>
          {/* pagination control */}
          <div className="flex justify-center items-center space-x-[20px]">
            {/* left arrow */}
            <button
              type="button"
              onClick={goToPeviousPage}
              disabled={currentPage === 1}
              className={`${
                currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <svg
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 1L1 7L7 13"
                  stroke="#1B0209"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            {/* pages number text */}
            <span className="text-[#1B0209] font-inter font-normal text-[14px] leading 24px">
              Page {currentPage} of {pagesNumber}
            </span>
            {/* right arrow */}
            <button
              type="button"
              onClick={goToNextPage}
              disabled={currentPage === pagesNumber}
              className={`${
                currentPage === pagesNumber
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              <svg
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L7 7L1 13"
                  stroke="#1B0209"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </>
  );
}
